import type { CmsApiFreeCodeBlockData } from '#/modules/cms/api/types/blocks/CmsApiFreeCodeBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';
import { dynamic } from '#/utils/dynamic';

export const CmsFreeCodeBlockMapping: CmsBlockMapping<CmsApiFreeCodeBlockData> =
  {
    invariant: [
      {
        prop: 'code',
        msg: 'Code required',
      },
    ],
    width: CmsMappedBlockWidth.NARROW,
    Component: dynamic(
      () =>
        import('./CmsFreeCodeBlock').then((m) => ({
          default: m.CmsFreeCodeBlock,
        })),
      { strategy: 'always' },
    ),
  };
